import React, { ReactNode, useState } from 'react'
import SearchBox from '../SearchBox'
import clsx from 'clsx'
import useShowMore from 'modules/common/hooks/useShowMore'
import MenuItem from './MenuItem'

type itemsPropType = {
  label: ReactNode
  value?: any
  items?: (...args: { [p: string]: any }[]) => void
}[]

type PropsType = {
  cx: () => void
  renderItem: (item: any, resetQuery: any) => ReactNode
  // Only required with showMore.
  translate?: (key: string, ...params: any[]) => string
  items: itemsPropType
  selectItem?: (item: any, resetQuery: any) => void
  className?: string
  showMore: boolean
  limit: number
  showMoreLimit: number
  show?: () => void
  searchForItems?: (value: any) => void
  searchable?: boolean
  isFromSearch?: boolean
  canRefine?: boolean
}

const MenuList = (props: PropsType) => {
  /************************
   * PROPS
   *************************/
  const {
    limit,
    showMoreLimit,
    renderItem: renderComponent,
    cx,
    items,
    searchable,
    canRefine,
    showMore,
    translate,
    searchForItems,
    isFromSearch,
    selectItem,
  } = props

  /************************
   * STATE
   *************************/
  const [query, setQuery] = useState('')
  const { showMoreProps, ShowMore, visibleItems } = useShowMore({
    limit,
    showMoreLimit,
    showMore,
    items,
  })
  const resetQuery = () => setQuery('')

  /*****************************
   * render
   ******************************/

  const renderSearchBox = () => {
    const noResults =
      !items || (items?.length === 0 && query !== '') ? (
        <div className={clsx('noResults')}>
          <>{translate && translate('noResults')}</>
        </div>
      ) : null
    return (
      <div className={clsx('searchBox')}>
        <SearchBox
          currentRefinement={query}
          refine={(value) => {
            setQuery('')
            searchForItems && searchForItems(value)
          }}
          // @ts-ignore
          focusShortcuts={[]}
          translate={translate}
          onSubmit={(e: React.FormEvent) => {
            e.preventDefault()
            e.stopPropagation()
            if (isFromSearch) {
              selectItem && selectItem(items[0], resetQuery)
            }
          }}
        />
        {noResults}
      </div>
    )
  }

  const searchBox = searchable ? renderSearchBox() : null

  if (!items || items.length === 0) {
    return <div>{searchBox}</div>
  }

  return (
    <div>
      {searchBox}
      <ul
        // @ts-ignore
        className={
          // @ts-ignore
          cx('list', !canRefine && 'list--noRefinement')
        }
      >
        {visibleItems.map(
          (item: { key?: string; label?: string; items: any[] }) => (
            <MenuItem
              key={item.key || item.label}
              item={item}
              isChild={false}
              renderComponent={renderComponent}
            />
          ),
        )}
        <ShowMore key="showMore" {...showMoreProps} />
      </ul>
    </div>
  )
}

MenuList.defaultProps = {
  className: '',
  isFromSearch: false,
  limit: 10,
}
export default MenuList
